// This file was automatically generated from SubPane.html.
// Please don't edit this file by hand.

goog.provide('el8.template.passport.SubPane');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.passport.SubPane.outline = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div><div class="el8BodyHeaderContainerWrap header-container"></div><div class="el8MainContainer content-container"></div></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.passport.SubPane.backButton = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<button class="back-trigger el8BackButton el8HeaderButton" type="button"><span class="el8BackButtonIcon"></span>Back</button>');
  if (!opt_sb) return output.toString();
};
